import store from '../store';
// eslint-disable-next-line no-unused-vars
import { logoutUserSuccess } from '../slices/auth/login/reducer';
import { toast } from 'react-toastify';
import { api } from '../config';

const PING_INTERVAL = 5000;

let _pingIntervalId = null;
const _waitingFetches = [];
let _isRetrying = false;
const TOAST_ID = 'api-disconnected';

const originalFetch = window.fetch;

function getToken() {
  const state = store.getState();
  return state.Login?.user?.token;
}

// eslint-disable-next-line no-unused-vars
function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? Date.now() >= payload.exp * 1000 : false;
  } catch {
    return false;
  }
}

async function pingServer() {
  const token = getToken();
  if (!token) return false;
  const res = await originalFetch(`${api.API_URL}/account/my-profile`, {
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });
  return res.ok;
}

function startGlobalPing() {
  if (_pingIntervalId) return;

  _pingIntervalId = setInterval(async () => {
    try {
      const online = await pingServer();
      if (!online) return;

      const token = getToken();
      // AUTO_LOGOUT_DISABLED_START — disabled per issue #24 (multi-login support), 2026-07-17
      // if (token && isTokenExpired(token)) {
      //   clearInterval(_pingIntervalId);
      //   _pingIntervalId = null;
      //   sessionStorage.clear();
      //   store.dispatch(logoutUserSuccess());
      //   window.location.href = '/login';
      //   return;
      // }
      void token;
      // AUTO_LOGOUT_DISABLED_END

      clearInterval(_pingIntervalId);
      _pingIntervalId = null;
      const entries = _waitingFetches.splice(0);
      if (entries.length === 0) return;

      _isRetrying = true;
      Promise.allSettled(entries.map(e => e.resolve())).finally(() => {
        _isRetrying = false;
      });
    } catch {
      // ping failed, continue interval
    }
  }, PING_INTERVAL);
}

window.fetch = async function (...args) {
  try {
    const response = await originalFetch(...args);

    // AUTO_LOGOUT_DISABLED_START — disabled per issue #24 (multi-login support), 2026-07-17
    // if (response.status === 401) {
    //   sessionStorage.clear();
    //   store.dispatch(logoutUserSuccess());
    //   window.location.href = '/login';
    //   throw new Error('Session expired');
    // }
    // AUTO_LOGOUT_DISABLED_END

    if (toast.isActive(TOAST_ID)) {
      toast.update(TOAST_ID, {
        render: 'Koneksi API tersambung kembali.',
        type: 'success',
        isLoading: false,
      });
      setTimeout(() => toast.dismiss(TOAST_ID), 2000);
    }

    return response;
  } catch (error) {
    if (!(error instanceof TypeError && error.message === 'Failed to fetch')) {
      throw error;
    }

    if (_isRetrying) {
      return new Promise((resolve, reject) => {
        _waitingFetches.push({
          reject,
          resolve: async () => {
            try {
              const retryResponse = await originalFetch(...args);
              if (toast.isActive(TOAST_ID)) {
                toast.update(TOAST_ID, {
                  render: 'Koneksi API tersambung kembali. Memuat data...',
                  type: 'success',
                  isLoading: false,
                });
                setTimeout(() => toast.dismiss(TOAST_ID), 2000);
              }
              resolve(retryResponse);
            } catch (retryError) {
              reject(retryError);
            }
          },
        });
        if (!_pingIntervalId) startGlobalPing();
      });
    }

    if (!toast.isActive(TOAST_ID)) {
      toast(
        <div>
          <span
            className='spinner-border spinner-border-sm me-2'
            role='status'
          />
          Koneksi API terputus. Mencoba kembali...
        </div>,
        {
          toastId: TOAST_ID,
          position: 'top-right',
          hideProgressBar: true,
          closeOnClick: false,
          closeButton: false,
          className: 'bg-warning text-black',
          autoClose: false,
        }
      );
    }

    return new Promise((resolve, reject) => {
      let cancelled = false;
      const onBeforeUnload = () => {
        cancelled = true;
      };
      window.addEventListener('beforeunload', onBeforeUnload);
      const entry = {
        reject,
        resolve: async () => {
          window.removeEventListener('beforeunload', onBeforeUnload);
          if (cancelled) return;
          if (toast.isActive(TOAST_ID)) {
            toast.update(TOAST_ID, {
              render: 'Koneksi API tersambung kembali. Memuat data...',
              type: 'success',
              isLoading: false,
              autoClose: false,
            });
            setTimeout(() => toast.dismiss(TOAST_ID), 2000);
          }
          try {
            const retryResponse = await originalFetch(...args);
            resolve(retryResponse);
          } catch (retryError) {
            reject(retryError);
          }
        },
      };

      _waitingFetches.push(entry);
      startGlobalPing();
    });
  }
};
